// extracted by mini-css-extract-plugin
export default {"subtitle":"stagesList_subtitle__mfsqw","stepsList":"stagesList_stepsList__IA-bw","stepsItem":"stagesList_stepsItem__Y3SWh"};